import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement, useState } from 'react';
import { S_CollapseSection } from '../../../../../design/sections/collapseSection/S_CollapseSection';
import { AnnotationToolsStatsTableContainer } from './table/AnnotationToolsStatsTable.container';
import { WorkPointsRulesModal } from './workPointsRulesModal/WorkPointsRulesModal';

interface IProps {
  endDate: moment.Moment;
  startDate: moment.Moment;
}

export const AnnotationToolsSection = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { startDate, endDate } = props;
  const subtitle = `(${startDate.format('DD MMMM yyyy')} - ${endDate.format('DD MMMM yyyy')})`;
  const [isWorkPointsRulesModalOpen, setIsWorkPointsRulesModalOpen] = useState<boolean>(false);

  const toggle = (): void => {
    setIsWorkPointsRulesModalOpen(!isWorkPointsRulesModalOpen);
  };

  const handleInfoIconClick = (e: MouseEvent): void => {
    e.stopPropagation();
    toggle();
  };

  return (
    <>
      <S_CollapseSection
        title={t('projects.details.stats.annotation_tools.annotation_tools')}
        subtitle={subtitle}
        showInfoIcon
        infoIconTooltip={t('projects.details.stats.annotation_tools.rules_modal_tooltip')}
        onInfoIconClick={handleInfoIconClick}
      >
        <AnnotationToolsStatsTableContainer />
      </S_CollapseSection>
      <WorkPointsRulesModal
        show={isWorkPointsRulesModalOpen}
        toggle={toggle}
      />
    </>
  );
});
